<template>
	<div ref="container" style="height:100%;position:relative;overflow:hidden;"></div>
</template>

<script>
import HighlightedMessageWidget from '@/widgets/HighlightedMessageWidget';

const mockSocket = { subscribe() { return 0; }, unsubscribe() {} };

export default {
	name: 'HighlightedMessageWidgetPreview',
	props: {
		settings: { type: Object, default: () => ({}) },
	},
	data() {
		return { services: [] };
	},
	watch: {
		settings: {
			deep: true,
			handler(s) { this._applySettings(s); },
		},
	},
	mounted() {
		this._initWidget();

		this.$api.get('channels')
			.then(channels => {
				const seen = new Set();
				this.services = channels.filter(c => {
					if(!c.service_icon_url || seen.has(c.service_id)) return false;
					seen.add(c.service_id);
					return true;
				});
				// Re-render so the service icon shows up now that we have channels
				this._applySettings(this.settings);
			})
			.catch(() => {});
	},
	beforeDestroy() {
		this._destroyWidget();
	},
	methods: {
		_initWidget() {
			this.widget = new HighlightedMessageWidget({
				container: this.$refs.container,
				api: null,
				socket: mockSocket,
				hash: 'preview',
			});

			// Call _build() directly to set up DOM without triggering API loads.
			this.widget._build();

			// Strip html/body rules so they don't affect the settings page layout
			const baseCSSElem = document.getElementById('hmBaseCSS');
			if(baseCSSElem) {
				baseCSSElem.textContent = baseCSSElem.textContent
					.replace(/(?:html|body)(?:\s*,\s*(?:html|body))?\s*\{[^}]*\}/g, '');
			}

			this._applySettings(this.settings);
		},
		_destroyWidget() {
			if(this.widget) {
				this.widget.destroy();
				this.widget = null;
				if(this.$refs.container) this.$refs.container.innerHTML = '';
			}
		},
		_buildSampleMessage() {
			let serviceId = null;
			let serviceName = null;
			let serviceIconUrl = null;
			if(this.services.length > 0) {
				const svc = this.services[Math.floor(Math.random() * this.services.length)];
				serviceId    = svc.service_id;
				serviceName  = svc.service_name || svc.service_id;
				serviceIconUrl = svc.service_icon_url;
			}
			return {
				message: {
					id: 'preview-1',
					serviceId,
					serviceName,
					serviceIconUrl,
					type: 'chat',
					sender: {
						displayName: 'CoolViewer',
						avatar: null,
					},
					spans: [{ text: 'This is an example highlighted message PogChamp' }],
				},
			};
		},
		_applySettings(s) {
			if(!this.widget) return;
			this.widget.applySettings({ ...s });
			// Re-render sample in new style
			this.widget._hiding  = false;
			this.widget._msgElem = null;
			this.widget.widgetElem.innerHTML = '';
			this.widget._handleHighlight(this._buildSampleMessage());
		},
	},
};
</script>
